import initializeComponent from 'Shared/react-initialize';
import { extendTheme } from '@chakra-ui/react';
import ChakraProviderWithoutResetCss from 'Shared/chakra-provider';
import { theme } from '@carpenter/theme';
import { ComponentType } from 'react';

export const extendedTheme = extendTheme(theme);

export function Initializer<T>(Component: ComponentType<T>) {
   return (props: T) => (
      <ChakraProviderWithoutResetCss theme={extendedTheme}>
         <Component {...props} />
      </ChakraProviderWithoutResetCss>
   );
}

export function initializeChakraComponent(name: any, Component: any, defaultProps = {}) {
   initializeComponent(name, Initializer(Component), defaultProps);
}
